import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  selectionsSetData: ['key', 'value'],
  selectionsToggleSidebar: ['side'],
  selectionsHideSidebar: ['side'],
  selectionsAddActiveTeam: ['teamId'],
  selectionsToggleActiveTeam: ['teamId']
})

export const SelectionTypes = Types
export default Creators

const isBigDevice = window.screen.width > 992
/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  activeTeams: {},
  activeProject: {},
  activeTabBar: 'videos',
  leftSideBarVisible: isBigDevice,
  rightSideBarVisible: isBigDevice
})

/* ------------- Reducers ------------- */

export const selectionsSetData = (state, { key, value }) => {
  return state.merge({ [key]: value })
}

export const selectionsToggleSidebar = (state, {side}) => {
  if (side === 'left') {
    return state.merge({
      leftSideBarVisible: !state.leftSideBarVisible,
      rightSideBarVisible: false
    })
  } else if (side === 'right') {
    return state.merge({
      rightSideBarVisible: !state.rightSideBarVisible,
      leftSideBarVisible: false
    })
  }
  return state
}

export const selectionsHideSidebar = (state, {side}) => {
  return state.merge({[`${side}SideBarVisible`]: false})
}

export const addActiveTeam = (state, { teamId }) => {
  return state.merge({ activeTeams: state.activeTeams.setIn([teamId], true) })
}

// export const removeActiveTeam = (state, { teamId }) => {
//   return state.merge({ activeTeams: state.activeTeams.setIn([teamId], false) })
// }

export const toggleActiveTeam = (state, { teamId }) => {
  return state.merge({
    activeTeams: state.activeTeams.setIn([teamId], !state.activeTeams[teamId])
  })
}

/* ------------- Selectors ------------- */

export const SelectionSelectors = {
  activeTeams: state => state.selections.activeTeams,
  activeProject: state => state.selections.activeProject,
  activeTabBar: state => state.selections.activeTabBar
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SELECTIONS_SET_DATA]: selectionsSetData,
  [Types.SELECTIONS_TOGGLE_SIDEBAR]: selectionsToggleSidebar,
  [Types.SELECTIONS_HIDE_SIDEBAR]: selectionsHideSidebar,
  [Types.SELECTIONS_ADD_ACTIVE_TEAM]: addActiveTeam,
  [Types.SELECTIONS_TOGGLE_ACTIVE_TEAM]: toggleActiveTeam,
})



// WEBPACK FOOTER //
// ./src/Redux/SelectionRedux.js